export const WORKER_SHIFTS_FETCH_BEGIN = 'syftacp/WORKER_SHIFTS_FETCH_BEGIN' as const
export const WORKER_SHIFTS_FETCH_FAILED = 'syftacp/WORKER_SHIFTS_FETCH_FAILED' as const
export const WORKER_SHIFTS_FETCH_SUCCEEDED = 'syftacp/WORKER_SHIFTS_FETCH_SUCCEEDED' as const
